import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/experiences/create-new-company/$step/')({
  beforeLoad: ({ search }) => {
    const raw = search as Record<string, string | undefined>;
    throw redirect({
      to: '/experiences/signup',
      search: { email: raw.email, registrationContext: undefined, returnUrl: undefined },
    });
  },
  component: () => null,
});
